import { zeroAddress } from 'viem'
import type { ChainConfig } from '../types'
import { getQuickNodeRpcUrl } from '../utils/getQuickNodeRpcUrl'

export const AVALANCHE = {
  name: 'avalanche',
  chainId: 43114,
  averageBlockTimeSeconds: 2,
  explorerUrl: 'https://snowtrace.io',
  nativeAsset: {
    assetAddress: zeroAddress,
    decimals: 18,
    name: 'AVAX',
    symbol: 'AVAX',
  },
  slip44: 60,
  wrappedNativeAsset: '0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7',
  blockscoutApiUrl: 'https://api.snowtrace.io/api',
  etherscanSupported: false,
  publicRpcUrls: [
    'https://avalanche-c-chain-rpc.publicnode.com',
    'https://0xrpc.io/avax',
    'https://endpoints.omniatech.io/v1/avax/mainnet/public',
    'https://avalanche.drpc.org',
    'https://1rpc.io/avax/c',
  ],
  getPrivateRpcUrls: () => {
    const avalanche: string[] = []
    process.env.ROUTEME_API_KEY && avalanche.push(`https://lb.routeme.sh/rpc/43114/${process.env.ROUTEME_API_KEY}`)
    const quickNodeUrl = getQuickNodeRpcUrl('avalanche')
    quickNodeUrl && avalanche.push(quickNodeUrl)
    process.env.INFURA_API_KEY && avalanche.push(`https://avalanche-mainnet.infura.io/v3/${process.env.INFURA_API_KEY}`)
    process.env.ALCHEMY_API_KEY &&
      avalanche.push(`https://avax-mainnet.g.alchemy.com/v2/${process.env.ALCHEMY_API_KEY}`)
    process.env.ANKR_API_KEY && avalanche.push(`https://rpc.ankr.com/avalanche/${process.env.ANKR_API_KEY}`)
    return avalanche
  },
} as const satisfies ChainConfig
